import { IonToast, IonProgressBar, IonImg, useIonViewWillLeave,   IonInfiniteScrollContent, IonInfiniteScroll, IonSpinner, IonRefresherContent, IonRefresher, IonFooter, IonList, IonRippleEffect, IonAvatar, useIonViewWillEnter, IonChip, useIonRouter, IonIcon, IonTextarea, IonGrid, IonRow, IonText, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useRef, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { createAnimation } from '@ionic/react';
import { checkmarkDoneOutline, checkmarkCircleOutline, closeOutline, sendOutline, chatbubbleEllipses, heart, heartOutline, heartCircle, heartCircleOutline, chatboxOutline } from 'ionicons/icons';

import { showTab, hideTab } from "../components/Tabs";
import NServer, { UIElement, handleRouteError, RegisterAppServices } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CreateContentInfo, ContentDetail, CountNum, ReponsiveContentItemResize } from '../data/item';
import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import LikeComp from "../components/LikeComp";
import Comment from "../components/Comment";
import CommentBox from "../components/CommentBox";
import ContentWrapper from "../components/ContentWrapper";

import './Main.css'; 
import '../pages/ChatMsg.css'; 

export interface ContentProp extends RouteComponentProps<{
    id : string,
    mode : string
    }> 
{};

var loading = false;
var com_index = 0;
var reply_mode = false;
const com_total = 10;
var refreshTimer : any;
var timeInterval = 0;
var mintTimer : any;

const Content : React.FC<ContentProp> = ({match}) => {

    const [content, setContent] = useState<ContentInfo>(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));
    const [contentItems, setContentItems] = useState<ContentDetail[]>([]);
    const [tokens, setTokens] = useState(0);
    const [url, setUrl] = useState("");
    const [showLikes, setShowLikes] = useState(false);
    const [supporters, setSupporters] = useState<ItemInfo[]>([]);
    const [comments, setComments] = useState<CommentInfo[]>([]);
    const [noMoreComment, setNoMoreComment] = useState(false);
    const [replyComment, setReplyComment] = useState<CommentInfo | null>(null);
    const [replyOnly, setReplyOnly] = useState(false);

    const [msg, setMsg] = useState("");

    const [loadingUI, setLoading] = useState(false);
    const inputRef = useRef<HTMLIonTextareaElement | null>(null);
    const [canSend, setCanSend] = useState(false);
    const [canRefresh, setCanRefresh] = useState(true);
    const heartRef = useRef<any>();
    const superHeartRef = useRef<any>();
    const [timer, setTimer] = useState(0);
    const [totalTimer, setTotalTimer] = useState(45);
    const [boosted, setBoosted] = useState(false);
    const [showMintMsg, setShowMintMsg] = useState(false);

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        setReplyOnly(false);
        hideTab();

        RegisterAppServices();
    });

    useIonViewWillLeave(() => {
        clearInterval(refreshTimer);
        clearTimeout(mintTimer);

        showTab();
    });

    // set the post as boost post
    const setBoostPost = (boost : boolean) => {
        setBoosted(boost);
        
        if (boost)
        {
            // init timer
            timeInterval = 0;
            setTimer(0);

            refreshTimer = setInterval(() => {
                if (timeInterval < totalTimer)
                    timeInterval += 0.1;
                setTimer(timeInterval);
            }, 100);
        }
        else
        {
            clearInterval(refreshTimer);
        }
    }

    // need to refresh
    useEffect(() => {
        setContent(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));
        setSupporters([]);
        setComments([]);

        setLoading(true);
        getData(true);
    },[match.params.id]);

    const getData = async (init: boolean = false) => {
        let v = new Vault();
        await v.read();

        loading = true;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_content_detail", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setContent(ReponsiveContentItemResize("content-box", server.data.content));

            setTokens(server.data.tokens);
            setSupporters(server.data.supporters);
            setComments(server.data.comments);
            setContentItems(server.data.items);

            com_index = server.data.comments.length;

            if (server.data.content.type == "video" || 
                server.data.content.type == "vidfile")
            {
                // process for video content
                if (server.data.items.length > 0)
                    setUrl(server.data.items[0].url);
                else
                    setUrl("");
            }

            // set the post boost
            if (init)
            {
                setTotalTimer(server.data.boost_timer);
                setBoostPost(server.data.boosted == 1);

                // setup boost function
                if (server.data.boosted == 1)
                {
                    mintTimer = setTimeout(() => {
                        mintPost();
                    }, server.data.boost_timer * 1000);
                }
            }

            if (server.data.market_item == 1)
            {
                // this is a marketplace item
                router.push("/market/" + match.params.id + "/n", "back", "pop");
            }
        }

        loading = false;
        setLoading(false);
    }

    // update a content
    const onUpdate = (index : number, content : ContentInfo) => {
        getData();
    }

    // go to likes
    const buyLine = () => {
        router.push("/token/wallet", "forward", "push");
    }

    // send a like
    const sendLike = async (likes : number) => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            likes: likes
        }

		var server = new NServer();
        await server.sendForm("nc_like", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            if (server.data.has_token == "no")
            {
                showAlert(GetStr(LANGUAGE.TXT_NO_NTOKEN_LIKE));
            }
        }
    }

    // load the supporters
    const getComments = async () => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            reply: reply_mode ? 1 : 0,
            s : com_index,
            e : com_total
        }

		var server = new NServer();
        await server.getList("nc_comments", state);

        if (server.success)
        {
            if (com_index == 0)
                setComments(server.data);
            else
                setComments(comments.concat(server.data));

            if (server.data.length < com_total)
                setNoMoreComment(true);
        }
    }

    const loadMoreComments = (ev: any) => {
        setTimeout(() => {
            // increase index
            com_index += com_total;

            getComments();

            ev.target.complete();
        }, 500);
    }  

    // when like is clicked
    const onLike = async () => {
        
        if (heartRef.current !== null) {
            const animation = createAnimation()
                .addElement(heartRef.current)
                .duration(500)
                .keyframes([
                    { offset: 0, transform: 'scale(1)' },
                    { offset: 0.5, transform: 'scale(1.5)', fill:'#D0FF10' },
                    { offset: 1, transform: 'scale(1)' }
                ])
                .easing('ease-out');
            animation.play();
        }
        
        // local update first for better UX
        let newContent = Object.create(content);
        newContent.likes = parseInt("" + content.likes) + 1;
        newContent.user_likes = parseInt("" + content.user_likes) + 1;
        setContent(newContent);

        // send a like
        await sendLike(1);

        await getData();
    }

    // when super like is clicked
    const onSuperLike = async () => {
        if (superHeartRef.current !== null) {
            const animation = createAnimation()
                .addElement(superHeartRef.current)
                .duration(1000)
                .keyframes([
                    { offset: 0, transform: 'scale(1)' },
                    { offset: 0.5, transform: 'scale(1.8)', fill:'#FF38F6' },
                    { offset: 1, transform: 'scale(1)' }
                ])
                .easing('ease-out');
            animation.play();
        }

        // local update first for better UX
        let newContent = Object.create(content);
        newContent.likes = parseInt("" + content.likes) + 10;
        newContent.user_likes = parseInt("" + content.user_likes) + 10;
        setContent(newContent);

        // send 10 likes
        await sendLike(10);

        await getData();
    }

    // show the comment box
    const onComment = async () => {
        setShowLikes(false);
    }

    // click on the like bars
    const clickLikeBar = () => {
        setShowLikes(!showLikes);
    }

    // click on the liked user
    const onLikeUserClicked = (item : ItemInfo) => {
        router.push("/user/" + item.id, "forward", "push");
    }

    const onCmtUserClicked = (cmt : CommentInfo) => {
        router.push("/user/" + cmt.user, "forward", "push");
    }

    // update the message
    const updateMsg = (val : string) => {
        if (val != '')
            setCanSend(true);
        else
            setCanSend(false);

        setMsg(val);
    }

    const processSendMsg = (e : any, img : string, ano : boolean) => {
        if (inputRef.current != null)
        {
            if (e.clientX >= inputRef.current.getBoundingClientRect().right)
            {
                // trigger the button
                sendMsg(img, ano);
                setReplyComment(null);
            }
        }
    }

    // send the message
    const sendMsg = async (img : string, ano : boolean) => {
        if (msg == "" && img == "")
            return;

        let v = new Vault();
        await v.read();

        let reply_id = -1;
        if (replyComment != null)
            reply_id = replyComment.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            msg: msg,
            img: img,
            ref: reply_id,
            ano: ano ? 1 : 0
        }

		var server = new NServer();
        await server.sendForm("nc_send_comment", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getData();
            
            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }
    
    // update the comments
    const updateComments = async () => {
        await getData();
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        loading = false;

        await getData();
        ev.detail.complete();
    };

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    // view the image
    const viewImage = (img : string) => {
        router.push("/imgviewer/" + encodeURIComponent(img), "forward", "push");
    }

    // reply to comment
    const setRepliedComment = (com : CommentInfo) => {
        setReplyComment(com);
    }

    // send the GIF message
    const sendGif = async (gif : string, ano : boolean) => {
        if (gif == "")
            return;

        // clear reply
        setReplyComment(null);

        let v = new Vault();
        await v.read();

        let reply_id = -1;
        if (replyComment != null)
            reply_id = replyComment.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            msg: gif,
            ref: reply_id,
            ano: ano ? 1 : 0
        }

		var server = new NServer();
        await server.sendForm("nc_send_gif", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            await getData();
            
            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // toggle the comment reply mode
    const toggleReplyMode = () => {
        reply_mode = !replyOnly;
        setReplyOnly(reply_mode);

        // update the content
        content.reply_only = reply_mode;
        let newContent = JSON.parse(JSON.stringify(content));
        
        setContent(newContent);
    }

    // update the content
    const onUpdateContent = (index : number, c : any, local : boolean) => {
        if (index == -2)
        {
            setRepliedComment(c);
            return;
        }

        if (local)
        {
            // copy content
            let newContent = JSON.parse(JSON.stringify(c));
            setContent(newContent);
        }
        else
        {
            getData();
        }
    }

    // mint the post
    const mintPost = async () => {
        setBoosted(false);

        // call mint function
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id,
            interval: timeInterval
        }

		var server = new NServer();
        await server.sendForm("nc_mint_post", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setShowMintMsg(true);
        }
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                    
                    <IonChip slot="end" onClick={ toggleReplyMode } >
                        <IonIcon icon={ replyOnly ? checkmarkDoneOutline : checkmarkCircleOutline} />
                        <IonLabel>{ GetStr(replyOnly ? LANGUAGE.TXT_CMT_REPLY_ALL : LANGUAGE.TXT_CMT_REPLY_ONLY) }</IonLabel>
                    </IonChip>
                    {
                        boosted ?
                    <IonProgressBar value={(timer/totalTimer)}></IonProgressBar>
                        :
                    <div/>
                    }
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonRefresher className="refresher" slot="fixed" disabled={!canRefresh} onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                {
                    content.id < 0 ?
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                            <div><IonText><h4>{ GetStr(LANGUAGE.TXT_CONTENT_404_CAP) }</h4></IonText></div>
                            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
                            <div><IonText>{ GetStr(LANGUAGE.TXT_CONTENT_404_DESC) }</IonText></div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                    :
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol id="content-box" size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            <ContentWrapper content={content} index={0} onUpdate={onUpdateContent} view="full" autoplay={match.params.mode != "ad"} />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            }
            <IonToast
                isOpen={showMintMsg}
                onDidDismiss={() => setShowMintMsg(false)}
                message={ GetStr(LANGUAGE.TXT_CONTENT_MINT_SUS) }
                position="bottom"
                duration={5000}
                buttons={[
                  {
                    text: 'X',
                    role: 'cancel',
                    handler: () => {
                        setShowMintMsg(false);
                    }
                  }
                ]}
              />
            </IonContent>
            {
                content.id >= 0 ?
            <IonFooter>
                {
                    !showLikes ?
                <CommentBox inputRef={inputRef} updateMsg={updateMsg} replyComment={replyComment} clearReply={()=>setReplyComment(null)} sendMsg={processSendMsg} sendGif={sendGif} />
                    :
                <div/>
                }
            </IonFooter>
                :
            <div/>
            }
        </IonPage>
    );
};

export default Content;